import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { commonStatus } from '@constants';
import { statusOptions } from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, TextField } from '@itz/react-cms-element';
import { Card, Col, Row } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const GroupDeviceForm = ({ formId, actions, dataDetail, onSubmit, setIsChangedFormValues, isEditing }) => {
    const translate = useTranslate();
    const statusValues = translate.formatKeys(statusOptions, ['label']);

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('deviceId');

    const handleSubmit = (values) => {
        values.deviceId = deviceId;
        const finalValues = {
            ...values,
            status: commonStatus.ACTIVE,
        };
        return mixinFuncs.handleSubmit(finalValues);
    };

    useEffect(() => {
        if (!dataDetail.id) return;
        form.setFieldsValue({
            ...dataDetail,
            // waitForNextGroup: dataDetail?.waitForNextGroup?.id,
        });
    }, [dataDetail]);

    useEffect(() => {
        if (!isEditing) {
            form.setFieldsValue({
                status: statusValues[0].value,
            });
        }
    }, [isEditing]);

    return (
        <BaseForm size={500} id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={10}>
                    <Col span={24}>
                        <TextField required label={<FormattedMessage defaultMessage="Name" />} name="name" />
                    </Col>
                </Row>

                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default GroupDeviceForm;
